module.exports = __webpack_public_path__ + "static/media/dragon-kingdom.d0af4eae.gif";